import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import GoalValidations from 'scaleflow/validators/goal';

export default class BusinessGoalsCreateController extends Controller {
  @service router;
  @service store;
  @service betaToggle;
  goalValidations = GoalValidations;

  @tracked activeStep = 0;
  @tracked goalChangeset = {};
  @tracked targetChangesets = [];
  targetChangesetFactory;
  @tracked selectedGoals = [];
  @tracked selectedMetrics = [];

  @tracked goalSearch = '';
  @tracked metricSearch = '';

  @action
  setActiveStep(index) {
    this.activeStep = index;
  }

  get activePeopleInOrganisation() {
    return this.store.peekAll('person').filter((p) => p.active);
  }

  get activeGoalsInOrganisation() {
    return this.store.peekAll('goal').filter((g) => !g.isNew);
  }

  get goals_without_parents() {
    return this.activeGoalsInOrganisation.filter(
      (goal) => !goal.parent.content,
    );
  }

  get metrics() {
    return this.store.peekAll('metric');
  }

  get personsList() {
    return this.store.peekAll('person').filter((p) => p.active);
  }

  @action
  handleOwnerSelect(changeset, item) {
    changeset.set('owner', item);
  }

  @action
  clearOwner(changeset) {
    changeset.set('owner', null);
  }

  @action
  handleStatusSelect(changeset, val) {
    changeset.set('active', val);
  }

  @action
  onDescriptionChange(changeset, e) {
    changeset.set('description', e);
  }

  @action
  goToListPage() {
    this.router.transitionTo('business.goals.list');
  }

  @action
  cancelForm() {
    this.goalChangeset.rollback();
    this.model.deleteRecord();
    this.targetChangesets.forEach((target) => {
      target.rollback();
      target.data.deleteRecord();
    });
    this.goToListPage();
  }

  @action
  rollbackChanges(changeset) {
    changeset.rollback();
  }

  @action
  handleGoalsSelect(goal, e) {
    const checked = e.target.checked;
    if (checked === undefined) return;
    if (checked) this.selectedGoals = [goal];
    else this.selectedGoals = [];
  }

  @action
  unlinkParentGoal() {
    this.selectedGoals = [];
    this.goalChangeset.set('parent', null);
  }

  @action
  handleMetricSelect(metric, e) {
    const checked = e.target.checked;
    if (checked === undefined) return;
    const metrics = this.selectedMetrics;
    const targetChangesets = this.targetChangesets;
    if (checked) {
      metrics.push(metric);
      targetChangesets.push(this.targetChangesetFactory());
    } else {
      const index = metrics.findIndex((_metric) => _metric.id === metric.id);
      if (index < 0) return;
      else {
        metrics.splice(index, 1);
        targetChangesets.splice(index, 1);
      }
    }
    this.selectedMetrics = metrics;
    this.targetChangesets = targetChangesets;
  }

  @action
  async saveGoal() {
    const goal = this.model;
    goal.mapChangesetToAttributes(this.goalChangeset.changes);
    if (this.selectedGoals.length) goal.set('parent', this.selectedGoals[0]);
    await goal.save();
    const promises = [];
    for (let i = 0; i < this.targetChangesets.length; i++) {
      const target = this.targetChangesets[i];
      target.set('goal', this.model);
      target.set('metric', this.selectedMetrics[i]);
      promises.push(target.save());
    }
    await Promise.all(promises);
    this.goToListPage();
  }

  /** OLD GOAL FORM  */

  @action
  async addGoal(changeset) {
    if (changeset.title?.length <= 0) return;
    try {
      changeset.save().then(() => {
        changeset.rollback();
        this.goToListPage();
      });
    } catch (err) {
      console.log(err);
    }
  }

  @action
  cancelOldForm(changeset) {
    changeset.rollback();
    this.model.deleteRecord();
    this.goToListPage();
  }

  @action
  async onGoalSubmit(changeset, e) {
    e.preventDefault();
    await this.addGoal(changeset);
  }
}
